<template>
  <header>
    <nav class="navbar navbar-expand-lg topHeader" :style="{
      backgroundImage: `linear-gradient(to left, #E7EAEE 0%, rgba(231,234,238,0.5) 60%), url('${topHeaderImage}')`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center'}">
      <div class="container position-relative">
        <div class="d-flex w-100 justify-content-between flex-wrap">
          <ul class="navbar-nav navbar1 d-flex align-items-center flex-row gap-2 mb-0">
            <div class="d-flex">
              <li class="nav-item" v-if="subdomain === 'kpk' || subdomain === 'localhost' || subdomain === 'sekretariati' || subdomain === 'kryesor' || subdomain === ''">
                <a class="nav-link logo" href="/">
                  <img src="../../assets/logo2.png" style="width:50px" class="mb-0">
                </a>
              </li>
              <!-- Show logo1.png for app-prokuroria or other subdomains (except kpk, sistemi, sekretariati) -->
              <li class="nav-item" v-if="subdomain === 'app-prokuroria' || (subdomain !== 'kpk' && subdomain !== 'sistemi' && subdomain !== 'sekretariati')">
                <a class="nav-link logo" href="/">
                  <img src="../../assets/logo1.png" style="width:50px" class="mb-0">
                </a>
              </li>
            </div>
            <li class="nav-item">
              <a class="nav-link text-nowrap textHeader text-start fw-bold" href="/">{{ title_header }}</a>
            </li>
          </ul>
          <ul class="navbar-nav navbar2 flex-row align-items-center gap-2 mobile-webmail-lang">
            <li class="nav-item webmail-mobile">
              <a class="nav-link webMail btn btn-primary" href="https://mail.rks-gov.net/owa/auth/logon.aspx?replaceCurrent=1&url=https%3a%2f%2fmail.rks-gov.net%2fowa%2f">Webmail</a>
            </li>
            <li class="nav-item dropdown selectLanguage lang-mobile">
              <a class="nav-link dropdown-toggle languages" href="#" data-bs-toggle="dropdown">{{ currentLanguage }}</a>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" @click="changeLanguage('AL')">SHQ</a></li>
                <li><a class="dropdown-item" @click="changeLanguage('SRB')">SRB</a></li>
                <li><a class="dropdown-item" @click="changeLanguage('ENG')">ENG</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="content">
      <ul class="exo-menu firstul">
        <li v-for="menu in menus.items" 
            :key="menu.key" 
            :class="{
              'drop-down': menu.children,
              'active': activeMenuKey === menu.key || activeSubMenuKeys[menu.key]
            }">
          <router-link 
              class="nav-link" 
              :to="menu.route" 
              @click.prevent="setActiveMenu(menu.key)" 
              :class="{
                'drop-down': menu.children,
                'active': activeMenuKey === menu.key || activeSubMenuKeys[menu.key]
              }">
            {{ menu.label }}
            <font-awesome-icon 
                icon="fa-solid fa-chevron-down" 
                class="ms-1" 
                v-if="menu.children" />
          </router-link>
          <ul class="drop-down-ul animated fadeIn secondul" 
              v-if="menu.children && activeMenuKey === menu.key">
            <li v-for="child in menu.children" :key="child.key">
              <router-link
                :to="formatRoute(child.route)"
                @click.prevent="setActiveSubMenu(menu.key, child.key)"
                :class="{ active: activeSubMenuKeys[menu.key] === child.key }">
                {{ child.label }}
              </router-link>
            </li>
          </ul>
        </li>
        <a href="#" class="toggle-menu visible-xs-block" @click.prevent="toggleMenu">
          <font-awesome-icon :icon="isMenuOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'" />
        </a>
      </ul>
    </div>
  </header>
</template>

<script>
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import i18n from '@/locales/i18n';
import { useMenuStore } from '@/store/MenuStore';
import $ from 'jquery';

export default {
  data() {
    return {
      menuStore: useMenuStore(),
      currentLanguage: 'SHQ',
      activeDropdown: null,
      subdomain: '',
      activeMenuKey: null,
      activeSubMenuKey: null,
      activeSubMenuKeys: {},
      isMenuOpen: false,
      topHeaderImage: '/navigation/sistemi.png',
    };
  },
  computed: {
    menus() {
      return this.menuStore.menus;
    },
    title_header() {
      return this.menus.title;
    },
  },
  methods: {
    changeLanguage(lang) {

      const normalized = String(lang).toUpperCase();
      i18n.locale = normalized;
      localStorage.setItem('lang', normalized);
      const labels = {
        AL: 'SHQ',
        SRB: 'SRB',
        ENG: 'ENG',
      };
      this.currentLanguage = labels[normalized] || labels['AL'];
      this.$emit('language-changed', normalized);
      window.location.reload();
    },
    formatRoute(route) {
      const [pathPart, queryString] = route.split('?');
      const query = queryString ? Object.fromEntries(new URLSearchParams(queryString)) : {};
      return {
        path: `${pathPart}`,
        query,
      };
    },
    setActiveMenu(menuKey) {
      const menu = this.menus.items.find(m => m.key === menuKey);
      this.activeMenuKey = menuKey;
      this.activeSubMenuKeys = {};
      this.activeDropdown = menu && menu.children ? menuKey : null;
      if (!menu.children) {
        this.isMenuOpen = false;
        $('.exo-menu').removeClass('display');
      }
    },
    setActiveSubMenu(menuKey, childKey) {
      this.activeSubMenuKeys = { [menuKey]: childKey };
      this.activeMenuKey = null;
      this.activeDropdown = null;
      this.isMenuOpen = false;
      $('.exo-menu').removeClass('display');
    },
    toggleDropdown(menuKey) {
      this.activeMenuKey = this.activeMenuKey === menuKey ? null : menuKey;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        $('.exo-menu').addClass('display');
      } else {
        $('.exo-menu').removeClass('display');
      }
    },
  },
  mounted() {
    const savedLang = (localStorage.getItem('lang') || 'AL').toUpperCase();
    const labels = {
      AL: 'SHQ',
      SRB: 'SRB',
      ENG: 'ENG',
    };
    this.currentLanguage = labels[savedLang];
    i18n.locale = savedLang;

     // ✅ Ky rresht e aktivizon dropdown-in Bootstrap pas renderimit
    import('bootstrap').then(({ Dropdown }) => {
      document.querySelectorAll('.dropdown-toggle').forEach(el => new Dropdown(el));
    });

    const host = window.location.hostname;
    const parts = host.split('.');

    // nëse jemi në domainin kryesor, trajtoje si "kryesor"
    if (host === 'prokuroria-rks.org' || host === 'www.prokuroria-rks.org') {
      this.subdomain = 'kryesor';
    } else {
      this.subdomain = parts[0];
    }

    // Set top header image based on subdomain
    const imageMap = {
      kpk: '/navigation/kpk.png',
      sekretariati: '/navigation/kpk.png',
      zkpsh: '/navigation/zkpsh.png',
      pa: '/navigation/pa.png',
      ps: '/navigation/ps.png',
      pthprishtine: '/navigation/pthprishtine.png',
      pthprizren: '/navigation/pthprizren.png',
      pthferizaj: '/navigation/pthferizaj.png',
      pthpeje: '/navigation/pthpeje.png',
      pthmitrovice: '/navigation/pthmitrovice.png',
      pthgjilan: '/navigation/pthgjilan.png',
      pthgjakove: '/navigation/pthgjakove.png',
      'app-prokuroria': '/navigation/sistemi.png',
      kryesor: '/navigation/sistemi.png',
    };
    this.topHeaderImage = imageMap[this.subdomain] || '/navigation/sistemi.png';
  },
  created() {
    this.menuStore.loadMenus();
    this.subdomain = this.menuStore.subdomain;
  },
  watch: {
    '$i18n.locale'() {
      this.menuStore.loadMenus();
    },
    $route() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style scoped>
:root {
  --primary-color-background: #E7EAEE;
  --secondary-color: #2ecc71;
  --heading-color: #333;
  --text-color: #666;
  --icon-color-menu: #0B0A21;
}

@media (max-width: 768px) {
  .navbar-nav {
    flex-direction: none;
  }
  .navbar-nav .nav-item {
    text-align: center;
  }
}

.systemMenuButton {
  color: var(--icon-color-menu);
  font-size: 24px;
}

.topHeader {
  width: 100%;
}

.secondHeader {
  background: #F8FAFD;
}

.textHeader {
  color: var(--title-color-1) !important;
  font-size: 26px;
  text-transform: uppercase;
  line-height: 18px;
  color: white !important;
  -webkit-text-stroke: 0.7px #2c3f5e;
  font-family: "Isidora Sans", sans-serif !important;
}

.webMail {
  background-color: #FFFFFF;
  padding: 5px 10px !important;
  border-radius: 8px;
  font-size: 14px;
  color: var(--title-color-1) !important;
  font-weight: 500;
}

.languages {
  font-weight: 400;
  font-size: 14px;
  color: var(--title-color-1) !important;
}

.secondHeader div div div ul li a {
  font-size: 16px;
  font-weight: 500;
  color: #101826 !important;
  line-height: 21px;
  letter-spacing: -0.2%;
}

li {
  cursor: pointer;
}

.dropdown-menu li a {
  color: var(--title-color-1) !important;
}

.dropdown-menu-primary {
  display: block;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  min-width: 220px;
  padding: 0px 0;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);
}

.dropdown-item-primary {
  display: block;
  width: 100%;
  padding: 10px 16px;
  color: #0B0A21 !important;
  font-size: 15px;
  text-align: left;
  text-decoration: none;
  transition: background-color 0.2s ease, padding-left 0.2s ease;
  border-radius: 4px;
}

.dropdown-item-primary:hover {
  background-color: #f1f1f1;
  padding-left: 10px;
}

.dropdown-menu-primary li {
  text-decoration: none;
  list-style: none;
}

.dropdown-item-primary.active {
  font-weight: bold;
}

.primaryMenu .nav-link {
  transition: transform 0.3s ease;
}

.primaryMenu .nav-link:hover {
  transform: scale(1.06);
  z-index: 1;
  color: white;
}

.d-flex .nav-item {
  margin-right: 10px; /* Spacing between logos */
}

.logo img {
  width: 50px;
  height: auto;
}

@media(max-width:991px) {
  .textHeader {
    font-size: 18px;
  }
  .logo img {
    width: 40px !important;
  }
  .navbar .d-flex.w-100 {
    flex-direction: column !important;
    align-items: stretch !important;
  }
  .navbar-toggler {
    align-self: flex-end;
  }
  .navbar {
    padding: 0 !important;
  }
  .selectLanguage ul {
    position: absolute !important;
    margin-left: -110px;
    padding: 0;
    margin-top: 0;
  }
  .topHeader {
    background-size: cover;
    background-position: center;
  }
  .exo-menu.firstul {
    display: flow-root !important;
  }
}

@media(max-width:769px) {
  .navbar-nav .nav-item {
    text-align: left !important;
  }
}

@media(max-width:575.98px) {
  .textHeader {
    font-size: 18px;
  }
  .navbar {
    padding: 0;
  }
  .topHeader {
    background-size: cover;
    background-position: center;
  }
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.25s cubic-bezier(.4, 0, .2, 1);
}

.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.7) rotate(-30deg);
}

.fade-scale-enter-to,
.fade-scale-leave-from {
  opacity: 1;
  transform: scale(1) rotate(0deg);
}

.navbar-toggler-icon,
.custom-x {
  display: inline-block;
  width: 25px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}

.clearfix:after,
.clearfix:before {
  content: '';
  display: table;
}

.clearfix:after {
  clear: both;
  display: block;
}

.firstul, .secondul {
  list-style: none;
  margin: 0;
  padding: 0;
}

a,
a:hover,
a.active,
a:active,
a:visited,
a:focus {
  color: #fefefe;
  text-decoration: none;
}

.exo-menu {
  width: 100%;
  float: left;
  list-style: none;
  position: relative;
  background: #2c3f5e;
}

.exo-menu > li {
  display: inline-block;
  float: left;
}

.exo-menu > li > a {
  text-decoration: none;
  text-transform: uppercase;
  border-right: 1px #74838f dotted;
  -webkit-transition: color 0.2s linear, background 0.2s linear;
  -moz-transition: color 0.2s linear, background 0.2s linear;
  -o-transition: color 0.2s linear, background 0.2s linear;
  transition: color 0.2s linear, background 0.2s linear;
}

.exo-menu > li > a.active,
.exo-menu > li > a:hover,
li.drop-down ul > li > a:hover {
  background: #F5BD2A !important;
  color: #2c3f5e !important;
  font-weight: 500;
}

.exo-menu i {
  float: left;
  font-size: 18px;
  margin-right: 6px;
  line-height: 20px !important;
}

li.drop-down,
.flyout-right,
.flyout-left {
  position: relative;
}

li.drop-down > ul {
  left: 0px;
  min-width: 230px;
}

.drop-down-ul {
  display: none;
  z-index: 999;
}

.flyout-right > ul,
.flyout-left > ul {
  top: 0;
  min-width: 230px;
  display: none;
  border-left: 1px solid #365670;
}

li.drop-down > ul > li > a,
.flyout-right ul > li > a,
.flyout-left ul > li > a {
  color: #fff;
  display: block;
  padding: 10px 15px;
  text-decoration: none;
  background-color: #365670;
  border-bottom: 1px dotted #547787;
  -webkit-transition: color 0.2s linear, background 0.2s linear;
  -moz-transition: color 0.2s linear, background 0.2s linear;
  -o-transition: color 0.2s linear, background 0.2s linear;
  transition: color 0.2s linear, background 0.2s linear;
}

.flyout-right ul > li > a,
.flyout-left ul > li > a {
  border-bottom: 1px dotted #B8C7BC;
}

.flyout-mega-wrap {
  top: 0;
  right: 0;
  left: 100%;
  width: 100%;
  display: none;
  height: 100%;
  padding: 15px;
  min-width: 742px;
}

h4.row.mega-title {
  color: #eee;
  margin-top: 0px;
  font-size: 14px;
  padding-left: 15px;
  padding-bottom: 13px;
  text-transform: uppercase;
  border-bottom: 1px solid #ccc;
}

.flyout-mega ul > li > a {
  font-size: 90%;
  line-height: 25px;
  color: #fff;
  font-family: inherit;
}

.flyout-mega ul > li > a:hover,
.flyout-mega ul > li > a:active,
.flyout-mega ul > li > a:focus {
  text-decoration: none;
  background-color: transparent !important;
  color: #ccc !important;
}

.mega-menu {
  left: 0;
  right: 0;
  padding: 15px;
  display: none;
  padding-top: 0;
  min-height: 100%;
}

h4.row.mega-title {
  color: #eee;
  margin-top: 0px;
  font-size: 14px;
  padding-left: 15px;
  padding-bottom: 13px;
  text-transform: uppercase;
  border-bottom: 1px solid #547787;
  padding-top: 15px;
  background-color: #365670;
}

.mega-menu ul li a {
  line-height: 25px;
  font-size: 90%;
  display: block;
}

ul.stander li a {
  padding: 3px 0px;
}

ul.description li {
  padding-bottom: 12px;
  line-height: 8px;
}

ul.description li span {
  color: #ccc;
  font-size: 85%;
}

a.view-more {
  border-radius: 1px;
  margin-top: 15px;
  background-color: #009FE1;
  padding: 2px 10px !important;
  line-height: 21px !important;
  display: inline-block !important;
}

a.view-more:hover {
  color: #fff;
  background: #0DADEF;
}

ul.icon-des li a i {
  color: #fff;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  text-align: center;
  background-color: #009FE1;
  line-height: 35px !important;
}

ul.icon-des li {
  width: 100%;
  display: table;
  margin-bottom: 11px;
}

.Blog {
  left: 0;
  display: none;
  color: #fefefe;
  padding-top: 15px;
  background: #547787;
  padding-bottom: 15px;
}

.Blog .blog-title {
  color: #fff;
  font-size: 15px;
  text-transform: uppercase;
}

.Blog .blog-des {
  color: #ccc;
  font-size: 90%;
  margin-top: 15px;
}

.Blog a.view-more {
  margin-top: 0px;
}

.Images {
  left: 0;
  width: 100%;
  display: none;
  color: #fefefe;
  padding-top: 15px;
  background: #547787;
  padding-bottom: 15px;
}

.Images h4 {
  font-size: 15px;
  margin-top: 0px;
  text-transform: uppercase;
}

.flyout-right ul > li > a,
.flyout-left ul > li > a,
.flyout-mega-wrap,
.mega-menu {
  background-color: #547787;
}

.Blog:hover,
.Images:hover,
.mega-menu:hover,
.drop-down-ul:hover,
li.flyout-left > ul:hover,
li.flyout-right > ul:hover,
.flyout-mega-wrap:hover,
li.flyout-left a:hover + ul,
li.flyout-right a:hover + ul,
.blog-drop-down > a:hover + .Blog,
li.drop-down > a:hover + .drop-down-ul,
.images-drop-down > a:hover + .Images,
.mega-drop-down a:hover + .mega-menu,
li.flyout-mega > a:hover + .flyout-mega-wrap {
  display: block;
}

@media (min-width:767px) {
  .exo-menu > li > a {
    display: block;
    padding: 10px 15px;
  }
  .mega-menu,
  .flyout-mega-wrap,
  .Images,
  .Blog,
  .flyout-right > ul,
  .flyout-left > ul,
  li.drop-down > ul {
    position: absolute;
  }
  .flyout-right > ul {
    left: 100%;
  }
  .flyout-left > ul {
    right: 100%;
  }
}

@media (max-width:767px) {
  a.toggle-menu {
    display: block !important;
  }
  .exo-menu {
    min-height: 40px;
    background-color: #2c3f5e;
    width: 100%;
  }
  .exo-menu > li > a {
    width: 100%;
    display: none;
  }
  .exo-menu > li {
    width: 100%;
  }
  .display.exo-menu > li > a {
    display: block;
    padding: 10px 22px;
  }
  .mega-menu,
  .Images,
  .Blog,
  .flyout-right > ul,
  .flyout-left > ul,
  li.drop-down > ul {
    position: relative;
  }
  .navbar2 {
    justify-content: space-between !important;
  }
}

@media (max-width:767px) {
  .mobile-header-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .mobile-header-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .mobile-header-bottom {
    width: 100%;
    padding: 0 16px;
    display: flex;
    justify-content: flex-end;
  }
  .webMail {
    font-size: 13px;
    padding: 4px 8px;
  }
  .selectLanguage {
    font-size: 13px;
  }
  .textHeader {
    text-align: center !important;
    font-size: 18px !important;
  }
  .navbar1 {
    justify-content: center !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .navbar .d-flex.w-100 {
    flex-direction: row !important;
    align-items: center !important;
    flex-wrap: nowrap !important;
    justify-content: space-between !important;
    gap: 0 !important;
  }
  .navbar-nav.d-flex.align-items-center.flex-row.gap-2.mb-0 {
    flex-direction: row !important;
    align-items: center !important;
    gap: 10px !important;
    margin-bottom: 0 !important;
  }
  .navbar-nav.ms-auto.flex-row.align-items-center.gap-2 {
    flex-direction: row !important;
    align-items: center !important;
    gap: 10px !important;
  }
  .nav-item .nav-link.logo img {
    width: 45px !important;
  }
  .textHeader {
    font-size: 18px;
    white-space: nowrap;
  }
  .selectLanguage .dropdown-menu {
    margin-left: -80px;
  }
}

a.toggle-menu {
  display: none;
  position: absolute;
  right: 0px;
  padding: 0px 15px;
  font-size: 27px;
  background-color: #ccc;
  color: #23364B;
  top: 0px;
}

.content {
  display: flex;
  justify-content: center;
}

.exo-menu.firstul {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  float: none !important;
}
</style>